import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InfiniteScroll from "react-infinite-scroller";
import { openEinvoicePreview } from "../../store/actions/detailsDocument/preview";

class ModalZoom extends Component {
  static propTypes = {
    auth: PropTypes.object,
    detailsDocument: PropTypes.object,
    contentPreview: PropTypes.string,
    downloadDocument: PropTypes.func,
    isEinvoice: PropTypes.bool,
    isVisible: PropTypes.bool,
    imgSrc: PropTypes.string,
    onClose: PropTypes.func,
    openPreviewPage: PropTypes.func,
    pagesTotal: PropTypes.number,
    isLoading: PropTypes.bool,
    waitForLoading: PropTypes.bool,
    transparentBackground: PropTypes.bool,
    hideDownload: PropTypes.bool,
    openEinvoicePreview: PropTypes.func,
    einvoiceType: PropTypes.string,
    getEinvoiceContentByType: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      pageIndexPreview: 1,
      imagesArray: [],
      documentId: null
    };
    this.couterFakeProgress = 0;
  }

  componentDidMount() {
    /** Elimino margini Modale non sovrapponibile lo style per problemi di className random */
    let nearestElem = document.getElementsByClassName("openWindowContainer");
    if (nearestElem && nearestElem.length > 0) {
      nearestElem[0].parentNode.style.maxHeight = "calc(100vh - 140px)";
      nearestElem[0].parentNode.parentNode.style.marginTop = "70px";

      if (nearestElem[1]) {
        // risolve il problema sulle scadenze
        nearestElem[1].parentNode.style.maxHeight = "calc(100vh - 140px)";
        nearestElem[1].parentNode.parentNode.style.marginTop = "70px";
      }
    }
  }

  componentDidUpdate() {
    /** Elimino margini Modale non sovrapponibile lo style per problemi di className random */
    let nearestElem = document.getElementsByClassName("openWindowContainer");
    if (nearestElem && nearestElem.length > 0) {
      nearestElem[0].parentNode.style.maxHeight = "calc(100vh - 140px)";
      nearestElem[0].parentNode.parentNode.style.marginTop = "70px";
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const prevArray = [...prevState.imagesArray];
    let previewContent = null;
    if (
      nextProps.imgSrc &&
      (nextProps.pagesTotal <= 1 || prevState.pageIndexPreview === 1)
    ) {
      previewContent = [nextProps.imgSrc];
    } else if (
      nextProps.pagesTotal > 1 &&
      nextProps.imgSrc &&
      prevArray.length <= nextProps.pagesTotal &&
      !prevState.imagesArray.includes(nextProps.imgSrc)
    ) {
      prevArray.push(nextProps.imgSrc);
      previewContent = prevArray;
    } else previewContent = prevState.imagesArray;
    return {
      ...prevState,
      imagesArray: previewContent
    };
  }

  loadMorePreview() {
    const {
      isLoading,
      openPreviewPage,
      pagesTotal,
      waitForLoading
    } = this.props;
    const { pageIndexPreview } = this.state;

    if (isLoading && waitForLoading) {
      return;
    }

    let nextCounter = pageIndexPreview + 1;
    if (nextCounter > pagesTotal) return;
    this.setState({ pageIndexPreview: nextCounter });

    openPreviewPage(nextCounter);
  }

  renderSimpleDownloadButton() {
    const { downloadDocument, hideDownload, previewContent } = this.props;
    return (
      <div className="openWindowContainer">
        {!hideDownload && (
          <div className="boxDownload">
            <div
              onClick={
                !hideDownload && previewContent !== null
                  ? downloadDocument.bind(this)
                  : () => {}
              }
            >
              <FontAwesomeIcon
                icon={["far", "arrow-to-bottom"]}
                style={{
                  color:
                    previewContent !== null ? "#0090d1" : "rgba(0,0,0,.65)",
                  fontSize: "16px",
                  cursor: previewContent !== null ? "pointer" : "not-allowed"
                }}
              />
              <span
                className={
                  previewContent !== null ? "download" : "downloadDisabled"
                }
              >
                {" "}
                Download{" "}
              </span>
            </div>
          </div>
        )}
      </div>
    );
  }

  renderImages() {
    const { isLoading, pagesTotal } = this.props;
    let nodeImages = [];
    for (let i = 0; i < this.state.imagesArray.length; i++) {
      nodeImages.push(<div className="zoomContainer" key={"imagePreview_" + i}>
        <img
          className="zoomDocument"
          src={this.state.imagesArray[i]}
          alt="preview documento zoomato"
        />
        {/* inserire quì il numero di pagina */}
        <div className="pageNumber">
          {" "}
            Pagina {i + 1}/{pagesTotal === 0 ? 1 : pagesTotal}
        </div>
      </div>);
    }
    return (
      <InfiniteScroll
        hasMore={this.state.pageIndexPreview < pagesTotal}
        initialLoad={false}
        loader={null}
        loadMore={this.loadMorePreview.bind(this)}
        pageStart={0}
        threshold={30}
        useWindow={false}
      >
        <div style={{ minWidth: 300 }}>
          {nodeImages}
          {isLoading && (
            <div style={{ display: "flex", width: "100%", margin: "auto" }}>
              <div style={{ flex: "0 0 auto", margin: "auto" }}>
                <FontAwesomeIcon
                  icon={["far", "circle-notch"]}
                  style={{ fontSize: "50px", color: "#0090d1" }}
                  spin
                />
              </div>
            </div>
          )}
        </div>
      </InfiniteScroll>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderSimpleDownloadButton()}
        {this.renderImages()}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    detailsDocument: state.detailsDocument
  };
}

function mapDispatchToProps(dispatch) {
  return {
    openEinvoicePreview: (
      auth, documentId, typePreview
    ) => {
      dispatch(openEinvoicePreview( documentId, typePreview));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalZoom);
